<template>
  <popup ref="popup" :loading="popupLoading">
    <div slot="body">
      <div class="dataTable autoFlex" v-if="listData">
        <div class="operator">
          <el-button @click="toNewSprBacklog()">批量生成待办</el-button>
          {{ msg }}
        </div>
        <el-table
          class="table"
          :data="listData.records"
          stripe
          border
          height="auto"
          @selection-change="selectionChange"
          v-loading="listLoading"
        >
          <el-table-column
            type="selection"
            width="55"
            fixed="left"
          ></el-table-column>
          <el-table-column
            prop="memberName"
            label="开发人员"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="readMan"
            label="审视人"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="sblName"
            label="sprint待办"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="bugcnt"
            label="待办审视出来的bug数量"
            align="center"
          ></el-table-column>
          <el-table-column prop="killbug" label="bug处理情况" align="center">
            <template slot-scope="scope">
              <el-tag size="mini" type="warning" v-if="scope.row.killbug == 1"
                >处理中</el-tag
              >
              <el-tag
                size="mini"
                type="success"
                v-else-if="scope.row.killbug == 2"
                >已处理</el-tag
              >
              <el-tag
                size="mini"
                type="danger"
                v-else-if="scope.row.killbug == 0"
                >未处理</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="260px"
            align="left"
            header-align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="toDetail(scope.$index, scope.row)"
                >结论详情</el-button
              >
              <el-button
                size="mini"
                v-if="scope.row.killbug == 1 || scope.row.killbug == 2"
                @click="toShowSBL(scope.$index, scope.row)"
                >显示待办</el-button
              >
              <el-button
                size="mini"
                v-if="scope.row.killbug == 0"
                @click="toUpdate(scope.$index, scope.row)"
                >编辑</el-button
              >
              <!-- <el-button icon="el-icon-plus" @click="toSave()">添加执行</el-button> -->
              <el-button
                size="mini"
                v-if="scope.row.killbug == 0"
                @click="toNewSprBacklog(scope.row, scope.$index)"
              >
                生成待办
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog
        title="审视结论"
        :visible.sync="dialogVisible"
        width="30%"
        :modal="false"
        center
      >
        <span v-html="conclusionDetail"></span>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <div class="pageBar">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          :total="listData.total"
          :page-size="page.size"
          :current-page="page.current"
          :layout="this.$constant.page.layout"
          :page-sizes="this.$constant.page.pageSizes"
        ></el-pagination>
      </div>
      <div slot="footer">
        <!-- <el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">确 定</el-button> -->
        <el-button type="danger" @click="close">关闭弹框</el-button>
      </div>

      <el-dialog
        :title="titleSBL"
        size="80%"
        class="el-dialog__body"
        v-model="formParameter"
        :visible.sync="revealSbl"
        width="70%"
        :modal="false"
        center
      >
        <el-form
          class="dataForm"
          ref="form"
          :inline="true"
          label-width="150px"
          :rules="rules1"
        >
          <el-row>
            <el-col :span="9">
              <el-form-item label="sprint代办">
                <el-input
                  :disabled="hasSBL"
                  v-model="formParameterName"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-checkbox
                @change="changeHasSBL"
                v-if="titleSBL == '生成待办'"
                v-model="hasSBL"
                >当前待办</el-checkbox
              >
            </el-col>
            <el-col :span="9">
              <el-form-item label="团队成员" clearable prop="pmid">
                <el-select
                  :readonly="true"
                  v-model="formParameterPmid"
                  autocomplete="off"
                >
                  <el-option
                    v-for="item in teammembes"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="执行状态" prop="states">
                <select-option-dictionary
                  v-model="formParameter.states"
                  dkey="spr-backlog-states"
                ></select-option-dictionary>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="预计工时" prop="hopegs"
                ><el-input
                  v-model="formParameter.hopegs"
                  autocomplete="off"
                ></el-input
              ></el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="计划开始" prop="pbgntm">
                <el-date-picker
                  v-model="pbgntm"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择计划开始时间"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="计划完成" prop="pendtm">
                <el-date-picker
                  v-model="formParameter.pendtm"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择计划完成时间"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="目标" prop="pgoal">
                <wang-edit :isupdt="isUpdtWedit" v-model="formParameter.pgoal">
                </wang-edit>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注" prop="remark">
                <el-input
                  type="textarea"
                  :rows="3"
                  v-model="formParameter.remark"
                  autocomplete="off"
                ></el-input
              ></el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="revealSbl = false">取 消</el-button>
          <el-button type="primary" @click="confirm">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 编辑 -->
      <el-dialog
        title="编辑审视记录"
        class="el-dialog__body"
        v-model="EditorParameter"
        :visible.sync="revealedit"
        width="70%"
        :modal="false"
        center
      >
        <el-form class="dataForm" ref="form" :inline="true" label-width="80px">
          <el-row>
            <el-col :span="4">
              <el-form-item label="开发人员" clearable>
                <el-input v-model="EditorParameter.memberName" disabled>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="审视人" clearable>
                <el-input v-model="EditorParameter.readMan" disabled>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="处理情况" clearable prop="killbug">
                <el-input v-model="EditorParameter.killbug" disabled>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="bug数量" clearable prop="bugcnt">
                <el-input v-model="EditorParameter.bugcnt"> </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="审视结论" clearable prop="conclusion">
                <wang-edit
                  :isupdt="isUpdtWedit"
                  v-model="EditorParameter.conclusion"
                >
                </wang-edit>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="审视截图" clearable prop="conclusion">
                <el-upload
                  :action="uploadUrl"
                  list-type="picture-card"
                  :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove"
                  multiple
                  :limit="3"
                  :headers="headers"
                  :on-success="handleSuccessed"
                  v-model="formParameter.imgUrl"
                  :file-list="fileList"
                  ref="up"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt="" />
                </el-dialog>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closeRecordEditer">关 闭</el-button>
          <el-button type="primary" @click="toSave()">确 定</el-button>
        </span>
      </el-dialog>
      <!--  显示待办的详细数据-->
      <el-dialog
        title="显示待办"
        class="el-dialog__body"
        v-model="SBLParameter"
        :visible.sync="showSbl"
        width="70%"
        :modal="false"
        center
      >
        <el-form class="dataForm" ref="form" :inline="true" label-width="80px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="sprint代办" prop="name"
                ><el-input
                  :readonly="true"
                  v-model="SBLParameter.name"
                  autocomplete="off"
                ></el-input
              ></el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="进度" prop="sadvance"
                ><el-slider disabled v-model="SBLParameter.sadvance"></el-slider
              ></el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="执行状态" prop="states">
                <select-option-dictionary
                  v-model="SBLParameter.states"
                  dkey="spr-backlog-states"
                ></select-option-dictionary>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="预计工时" prop="hopegs"
                ><el-input
                  v-model="SBLParameter.hopegs"
                  :readonly="true"
                  autocomplete="off"
                ></el-input
              ></el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="计划开始" prop="pbgntm">
                <el-date-picker
                  v-model="SBLParameter.pbgntm"
                  value-format="yyyy-MM-dd"
                  disabled
                  type="date"
                  placeholder="选择计划开始时间"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="计划完成" prop="pendtm">
                <el-date-picker
                  v-model="SBLParameter.pendtm"
                  value-format="yyyy-MM-dd"
                  disabled
                  type="date"
                  placeholder="选择计划完成时间"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="目标" prop="pgoal"
                ><span v-html="SBLParameter.pgoal"></span
              ></el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注" prop="remark">
                <span v-html="SBLParameter.remark"></span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="showSbl = false">关 闭</el-button>
        </span>
      </el-dialog>
    </div>
    <edit ref="edit"></edit>
  </popup>
</template>

<script>
import edit from "./edit.vue";
import popup from "@/components/popup/drawerPopup.vue";
import api from "@/api/sprint/survey_record/survey_record.js";
import apiBLG from "@/api/sprint/sprintBacklog/sprintBacklog.js";
import apiTeamMember from "@/api/team/teamMember/teamMember.js";
import apiSurvey from "@/api/sprint/survey/survey.js";
import selectOptionDictionary from "@/components/biz/selectOptionDictionary/selectOptionDictionary.vue";
import wangEdit from "@/components/wangEdit/wangEdit.vue";
import constant from "@/util/constant.js";
import { log } from 'console';
import { constants } from 'buffer';
export default {
  name: "listRecord",
  components: {
    popup,
    edit,
    selectOptionDictionary,
    wangEdit,
  },
  data() {
    return {
      headers: { jwttoken: localStorage.getItem("jwttoken") }, //本地获取
      popupLoading: false,
      confirmLoading: false,
      listLoading: false,
      parameter: {},
      surveys: [], //查询本sprint下状态为 进行中 的审视计划
      listData: [],
      surveyId: "",
      page: new this.$constant.pageObj(),
      dialogVisible: false,
      revealSbl: false, //显示生成待办页面

      revealedit: false, //显示编辑页面
      showSbl: false, //显示新待办详细信息页面
      EditorParameter: {}, //编辑页面的参数
      formParameter: {}, //生成待办的参数
      SBLParameter: {}, //显示待办的参数
      conclusionDetail: "",
      isUpdtWedit: false, //用于更新wangEdit
      teammembes: [], //队员
      proBackLogName: "",

      titleSBL: "生成待办",

      idex: 0, //当前处理的 审视记录编号

      hasSBL: false, //在已存在待办上添加

      sblId: "",
      sprintId: "",
      sblObj: {},
      selected: [], //选中的代表s
      formParameterName: null,
      formParameterPid: null,
      formParameterPmid: null, //SpringBackLog 队员
      msg: "",
      pbgntm: "",
      pgoalTxt: "", //缓存批量审视记录的合并text
      selectedkillbugs: [], //批量审视记录的选中killbug

      isUpdtWedit: false, //用于更新wangEdit

      rules1: {},
      fileList: [],
      uploadUrl: "",
      imgUrl: [],
      dialogImageUrl: "",
      dialogVisible: false,
      
    };
  },
  methods: {
    closeRecordEditer(){
          console.log(222222);
          this.revealedit = false; 
          this.fileList=[]; 
    }
    
    ,
    changeHasSBL() {
      if (this.hasSBL) {
        apiBLG.getOne({ sblId: this.sblId }, (res) => {
          this.sblObj = res.data;
          //	console.log("当前待办数据", this.sblObj);
          this.formParameterPid = this.sblObj.id;
          this.formParameterName =
            "[bug修正]-" + this.listData.records[this.idex].sblName;
        });
      } else {
        this.formParameterPid = null;
        this.formParameterName = "";
        this.sblObj = null;
      }
    },
    //根据搜索列表数据
    list() {
      let params = this.$utils.merger(
        { meetingId: this.parameter.meetingId, surveyId: this.parameter.id },
        this.page
      );
      api.list(params, (res) => {
      
        console.log(res.data);
        
        this.listData = res.data;
        this.listLoading = false;
        this.popupLoading = false;
      });
    },
    //去编辑
    toUpdate(index, row) {
    
      if (row.imgurl) {
        let imgArr= JSON.parse(row.imgurl);
        let ojb={};
         
         let arr=[];
         for (let i = 0; i < imgArr.length; i++) {
         
         let url= constant.serverUrl + imgArr[i];
         ojb.url=url;
         arr.push(ojb);
        
          
        
        
      }
       this.fileList=arr;
      }
      
     
      
      
      this.revealedit = true;
      this.EditorParameter = JSON.parse(JSON.stringify(row));

      this.isUpdtWedit = true;
      setTimeout(() => {
        this.isUpdtWedit = false;
      }, 100);

      this.EditorParameter.killbug = "未处理";
    },
    //编辑更新审视计划
    toSave() {
      this.EditorParameter.killbug = 0;
      api.update(this.EditorParameter, (res) => {
        this.$message({ message: "修改成功", type: "success" });
        this.revealedit = false;
        this.init();
      });
    },
    //显示生成的待办详情
    toShowSBL(idx, row) {
      this.showSbl = true;
      //根据审视记录id获取待办详细信息
      apiBLG.getOne({ sblId: row.nsblId }, (res) => {
        this.SBLParameter = res.data;
      });
    },
    //审视计划中打开审视记录弹框
    open(parameter, title, size) {
      this.parameter = parameter;
      //console.log("会议或审视计划传过来的参数open", this.parameter);
      this.sprintId = this.parameter.sprId;
      this.$refs.popup.open(title, size);
      this.$nextTick(() => {
        this.init();
      });
    },
    //会议中打开审视记录弹框
    open1(parameter, title, size) {
      //console.log("会议传过来的会议id open1", parameter);
      //根据会议id获取审视计划
      apiSurvey.getOnebyMeetingId(parameter, (res) => {
        this.open(res.data, title, size);
      });
    },
    closeDialog(flag) {
      flag = false;
    },
    //关闭弹框
    close() {
      //清空旧值
      this.isUpdtWedit = true;
      
      setTimeout(() => {
        this.isUpdtWedit = false;
      }, 100);
      this.$refs.popup.close();
    },
    //改变每页显示数量
    sizeChange(val) {
      this.page.size = val;
      this.list();
    },
    //改变现在的页码
    currentChange(val) {
      this.page.current = val;
      this.list();
    },

    init() {
      this.popupLoading = true;
      //清除等待
      // this.confirmLoading = false;
      //清空内容
      this.listData = [];
      this.listLoading = true;
      this.surveyId = this.parameter.surveyId;
      this.list();
      this.fileList=[];
       this.uploadUrl =
        constant.serverUrl + "/surveyRecord/surveyRecord/uploadImg";

      //队员
      if (!this.teammembes || this.teammembes.length == 0) {
        apiTeamMember.getTMemberBySprId(false, (response) => {
          if (response.data) {
            this.teammembes = response.data;
            this.$caches.teammembes.set(this.teammembes);
          }
        });
      }
    },
    toDetail(idx, row) {
      this.conclusionDetail = row.conclusion;
      this.dialogVisible = true;
    },
    //改变选择项
    selectionChange(val) {
      this.msg = "";
      //清空
      this.selected = [];
      this.pgoalTxt = [];

      this.formParameter.pgoal = "";
      this.selectedkillbugs = [];

      for (let item of val) {
        this.selected.push(item.id);
        this.selectedkillbugs += item.killbug + ",";
        this.pgoalTxt += item.conclusion + "<BR>";
      }

      //取回序号
      if (this.selected.length == 1) {
        for (let i = 0; i < this.listData.records.length; i++) {
          //	console.log(" this.idex000", this.listData.records[i], this.selected[0]);
          if (this.listData.records[i].id == this.selected[0]) {
            this.idex = i;
            //console.log(" this.idex", this.idex);
            break;
          }
        }
      }

      //console.log("选中的killbug", this.selectedkillbugs);
      this.formParameter.pgoal = this.pgoalTxt;
      //console.log("选中的审视记录id this.selected", this.selected);

      if (this.selected.length > 0) {
        this.msg = "本次选中:" + this.selected.length + "条";
      }
    },
    //生成待办
    confirm() {
      this.formParameter.sprId = this.sprintId;

      if (this.formParameterPid) {
        this.formParameter.pid = this.formParameterPid;
      }

      if (this.pbgntm) {
        this.formParameter.pbgntm = this.pbgntm;
      }

      this.formParameter.name = this.formParameterName;
      this.formParameter.pmid = this.formParameterPmid;

      if (this.selected.length == 0) {
        //一个审视记录时,保存审视记录id
        this.selected.push(this.listData.records[this.idex].id);
      }

      //将选中的审视记录id surveyids赋值给save参数内
      let params = this.$utils.merger(
        { surveyRecordIds: this.selected },
        this.formParameter
      );

      apiBLG.saveFrSurvey(
        params,
        (response) => {
          this.$utils.msg.success(response.msg);
          this.confirmLoading = false;
          //回显刷新
          if (this.selected.length == 1) {
            this.listData.records[this.idex].killbug = 1;
          } else {
            this.list();
          }

          // close
          this.revealSbl = false;

          //console.log("this.formParameter保存", this.formParameter);
          this.formParameter = {};
        },
        (response) => {
          this.$utils.msg.warning(response.msg);
          this.confirmLoading = false;
        }
      );
    },
    toNewSprBacklog(row, idex) {
      this.formParameterName = "";
      this.formParameterPid = "";
      this.hasSBL = false;
      //清除数据

      if (row) {
        //批量
        this.selectOne2SBL(row, idex);
      } else {
        //只有一个
        if (this.selected.length == 1) {
          this.selectOne2SBL(this.listData.records[this.idex], this.idex);
          return;
        }

        this.titleSBL = "合并生成待办";

        this.formParameter.pgoal = this.pgoalTxt;
        //没默选
        this.formParameterPmid = null;

        if (
          this.selectedkillbugs.includes(1) ||
          this.selectedkillbugs.includes(2)
        ) {
          this.$utils.msg.info("请选择不是未处理的审视记录");
          return;
        }

        if (!this.selected || this.selected.length == 0) {
          this.$utils.msg.info("请选择至少一行");
          return;
        }
        this.formParameter.states = "未开始";
        this.formParameterName = "[bug批量修正]-";
        this.revealSbl = true;
      }

      // 2 to    4 for
    },
    selectOne2SBL(row, idex) {
      this.titleSBL = "生成待办";
      this.idex = idex;
      let parameter = { sblId: row.sblId, sprId: this.parameter.sprId };
      this.sblId = row.sblId;

      //取得当前-开发人员
      apiBLG.selectPmid(parameter, (res) => {
        //console.log("  当前开发人员的id", res);
        //默认
        this.formParameterPmid = res.msg;
        this.formParameter.states = "未开始"; //默认值
        this.pbgntm = new Date(); //开始时间默认值 -当前时间

        //强制绑定值 后 刷新
        this.isUpdtWedit = true;
        this.formParameter.pgoal = row.conclusion;
        setTimeout(() => {
          this.isUpdtWedit = false;
        }, 100);

        this.revealSbl = true;
      });
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    //删除之前执行的方法
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除${file.name}吗?`);
    },
    //文件删除的方法
    handleRemove(file, fileList) {
      //此处elementui会自动去掉删除的图片，fileList数组会自动清楚删除的图片的地址
      //所以fileList就是删除成功之后的数组，不需要在进行任何处理
      console.log(file, fileList);
      this.fileList = fileList;
    },
    /* 上传 */
    handleSuccessed(res, file) {
      this.imgUrl.push(res.data);

      this.$set(this.formParameter, "imgUrl", this.imgUrl);
      console.log(this.formParameter.imgUrl);
      // api.uploadImg(parameter,(response)=>{
      //   console.log("请求成功");
      // });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";

.el-dialog__body {
  height: 1400px;
  margin-top: -80px;
}



</style>
